import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Route prices
export const getRoutePrices = (originId = null, destinationId = null) => {
  const params = new URLSearchParams();
  if (originId) params.append('origin_id', originId);
  if (destinationId) params.append('destination_id', destinationId);
  return api.get(`/route-prices?${params.toString()}`);
};
export const calculateRoutePrice = (originId, destinationId) =>
  api.get(`/route-prices/calculate?origin_id=${originId}&destination_id=${destinationId}`);
export const createRoutePrice = (data) => api.post('/route-prices', data);
export const updateRoutePrice = (id, data) => api.put(`/route-prices/${id}`, data);
export const deleteRoutePrice = (id) => api.delete(`/route-prices/${id}`);

// Zones
export const getZones = (activeOnly = false) => 
  api.get(`/zones${activeOnly ? '?active_only=true' : ''}`);
export const getAirports = () => 
  api.get('/zones').then(res => ({ ...res, data: res.data.filter(z => z.zone_type === 'airport') }));
export const getDestinations = () => 
  api.get('/zones').then(res => ({ ...res, data: res.data.filter(z => z.zone_type === 'destination') }));
export const createZone = (data) => api.post('/zones', data);
export const updateZone = (id, data) => api.put(`/zones/${id}`, data);
export const deleteZone = (id) => api.delete(`/zones/${id}`);

// Hotels
export const getHotels = (zoneId = null, activeOnly = false) => {
  const params = new URLSearchParams();
  if (zoneId) params.append('zone_id', zoneId);
  if (activeOnly) params.append('active_only', 'true');
  return api.get(`/hotels?${params.toString()}`);
};
export const getHotelsPaginated = (page = 1, limit = 50, zoneId = null) => {
  const params = new URLSearchParams({ page, limit });
  if (zoneId) params.append('zone_id', zoneId);
  return api.get(`/hotels?${params.toString()}`);
};
export const createHotel = (data) => api.post('/hotels', data);
export const updateHotel = (id, data) => api.put(`/hotels/${id}`, data);
export const deleteHotel = (id) => api.delete(`/hotels/${id}`);

// Vehicles
export const getVehicles = (activeOnly = false) => 
  api.get(`/vehicles${activeOnly ? '?active_only=true' : ''}`);
export const createVehicle = (data) => api.post('/vehicles', data);
export const updateVehicle = (id, data) => api.put(`/vehicles/${id}`, data);
export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`);

// Excursions
export const getExcursions = (activeOnly = false) => 
  api.get(`/excursions${activeOnly ? '?active_only=true' : ''}`);
export const createExcursion = (data) => api.post('/excursions', data);
export const updateExcursion = (id, data) => api.put(`/excursions/${id}`, data);
export const deleteExcursion = (id) => api.delete(`/excursions/${id}`);

// Testimonials
export const getTestimonials = (activeOnly = false) => 
  api.get(`/testimonials${activeOnly ? '?active_only=true' : ''}`);
export const createTestimonial = (data) => api.post('/testimonials', data);
export const updateTestimonial = (id, data) => api.put(`/testimonials/${id}`, data);
export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`);

// FAQs
export const getFaqs = (activeOnly = false) => 
  api.get(`/faqs${activeOnly ? '?active_only=true' : ''}`);
export const createFaq = (data) => api.post('/faqs', data);
export const updateFaq = (id, data) => api.put(`/faqs/${id}`, data);
export const deleteFaq = (id) => api.delete(`/faqs/${id}`);

// Reservations
export const getReservations = (status = null) => {
  const params = status ? `?status=${status}` : '';
  return api.get(`/reservations${params}`);
};
export const createReservation = (data) => api.post('/reservations', data);
export const updateReservationStatus = (id, status) => 
  api.put(`/reservations/${id}/status?status=${status}`);
export const deleteReservation = (id) => api.delete(`/reservations/${id}`);

// Settings
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

export default api;
